import { Box, MenuItem, TextField } from "@mui/material";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { SyncLoader } from "react-spinners";
import { toast, ToastContainer, Zoom } from "react-toastify";
import { handleEditClose } from "../../redux/Reducer/ModalSlice";
import { ThemButton } from "../Login/Login.style";
import StyledInput from "../Share/StyledInput";
import { ErrorMessage } from "../style/Table.style";
import "react-toastify/dist/ReactToastify.css";
const EditSponsor = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState();
  const sponsorData = useSelector((state) => state.Modal.val);

  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();

  const onSubmit = (data, e) => {
    // alert(JSON.stringify(data));
    setIsLoading(true);
    const formData = new FormData();

    formData.append("sponsor_id", sponsorData.sponsor_id);
    formData.append("sponsor_name", data.sponsor_name);
    formData.append("spon_phone", data.spon_phone);
    formData.append("spon_email", data.spon_email);
    formData.append("spon_address", data.spon_address);
    formData.append("cont_person_nm", data.cont_person_nm);
    formData.append("cont_person_ph", data.cont_person_ph);
    formData.append("active_flag", data.active_flag);

    fetch(
      `${process.env.REACT_APP_API_URL}/api/updateSponsor`,
      {
        method: "POST",
        body: formData,
      }
    )
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        if (data.success === true) {
          toast.success("Sponsor update successful", {
            position: toast.POSITION.TOP_CENTER,
          });
            dispatch(handleEditClose());
        } else if (data.duplicate === true) {
          toast.error("This sponsor is already exists!!", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      })
      .finally(() => setIsLoading(false));
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Box p="20px">
        <Box pb="20px">
          <TextField
            size="small"
            fullWidth
            label="Sponsor Name*"
            variant="outlined"
            defaultValue={sponsorData.sponsor_name}
            {...register("sponsor_name", { required: true })}
          />
          {errors?.sponsor_name?.type === "required" && (
            <ErrorMessage>Sponsor Name is required*</ErrorMessage>
          )}
        </Box>

        <Box pb="20px">
          <StyledInput
            type="number"
            size="small"
            fullWidth
            label="Sponsor Phone*"
            variant="outlined"
            defaultValue={sponsorData.spon_phone}
            {...register("spon_phone", {
              required: true,
              maxLength: 11,
              minLength: 11,
            })}
          />
          {errors?.spon_phone?.type === "required" && (
            <ErrorMessage>Sponsor phone number is required*</ErrorMessage>
          )}
          {errors?.spon_phone?.type === "maxLength" && (
            <ErrorMessage>Sponsor phone number maximum 11 digit</ErrorMessage>
          )}
          {errors?.spon_phone?.type === "minLength" && (
            <ErrorMessage>Sponsor phone number must be 11 digit</ErrorMessage>
          )}
        </Box>

        <Box pb="20px">
          <TextField
            type="email"
            size="small"
            fullWidth
            label="Sponsor Email"
            variant="outlined"
            defaultValue={sponsorData.spon_email}
            {...register("spon_email", {
              // required: true,
              pattern: /^\S+@\S+$/i,
            })}
          />
          {errors?.spon_email?.type === "required" && (
            <ErrorMessage>Sponsor Name is required*</ErrorMessage>
          )}
          {errors?.spon_email?.type === "pattern" && (
            <ErrorMessage>This is not email account*</ErrorMessage>
          )}
        </Box>

        <Box pb="20px">
          <TextField
            size="small"
            fullWidth
            label="Sponsor Address"
            variant="outlined"
            defaultValue={sponsorData.spon_address}
            {...register("spon_address", {
              // required: true
            })}
          />
          {errors?.spon_address?.type === "required" && (
            <ErrorMessage>Sponsor Address is required*</ErrorMessage>
          )}
        </Box>

        <Box pb="20px">
          <TextField
            size="small"
            fullWidth
            label="Contact person"
            variant="outlined"
            defaultValue={sponsorData.cont_person_nm}
            {...register("cont_person_nm", {
              // required: true
            })}
          />
          {errors?.cont_person_nm?.type === "required" && (
            <ErrorMessage>Contact person Name is required*</ErrorMessage>
          )}
        </Box>

        <Box pb="20px">
          <StyledInput
            type="number"
            size="small"
            fullWidth
            label="Phone Number of Contact Person"
            variant="outlined"
            defaultValue={sponsorData.cont_person_ph}
            {...register("cont_person_ph", {
              // required: true,
              maxLength: 11,
              minLength: 11,
            })}
          />
          {errors?.cont_person_ph?.type === "required" && (
            <ErrorMessage>
              Contact person Phone Number is required*
            </ErrorMessage>
          )}

          {errors?.cont_person_ph?.type === "maxLength" && (
            <ErrorMessage>
              Contact person Phone Number maximum 11 digit
            </ErrorMessage>
          )}
          {errors?.cont_person_ph?.type === "minLength" && (
            <ErrorMessage>
              Contact person Phone Number must be 11 digit
            </ErrorMessage>
          )}
        </Box>

        <Box>
          <TextField
            select
            defaultValue={sponsorData.active_flag}
            size="small"
            fullWidth
            label="Active Status"
            variant="outlined"
            {...register("active_flag", {
              // required: true
            })}
          >
            <MenuItem value="Y">Active</MenuItem>
            <MenuItem value="N">Inactive</MenuItem>
          </TextField>
          {errors?.active_flag?.type === "required" && (
            <ErrorMessage>Active status is required*</ErrorMessage>
          )}
        </Box>
      </Box>

      <Box sx={{ mb: "15px", display: "flex", justifyContent: "center" }}>
        {isLoading ? (
          <ThemButton
            style={
              {
                //   width: "30%",
              }
            }
            type="submit"
          >
            <SyncLoader color="#FFFFFF" size={8} />
          </ThemButton>
        ) : (
          <ThemButton
            style={
              {
                //   width: "30%",
              }
            }
            type="submit"
          >
            Update Sponsor
          </ThemButton>
        )}
      </Box>
      <ToastContainer
        autoClose={2000}
        limit={1}
        transition={Zoom}
        toastStyle={{ border: "2px solid crimson" }}
      />
    </form>
  );
};

export default EditSponsor;
